// eslint-disable-next-line no-restricted-imports
import { Flex, Text, useMantineTheme } from '@mantine/core';

import { CurrencyConvertor } from '~/components/utils/formatters';
import { Text as DesignSystemText } from '~/domains/design-system/Text';

type PlayerCardTagProps = {
  className: string;
  tag?: {
    position?: string;
    salary?: number;
    injury?: string;
    playerTier?: string;
  };
};

function PlayerCardTag({ tag, className }: PlayerCardTagProps) {
  const theme = useMantineTheme();
  const displayTierOrPositionLabel = tag?.playerTier || tag?.position;

  return (
    <>
      {displayTierOrPositionLabel ? (
        <Flex
          className={className}
          left={0}
          bottom={0}
          sx={{ borderTopRightRadius: theme.radius.md }}
          bg={theme.white}
        >
          <Text weight="bold" size="xs">
            {displayTierOrPositionLabel}
          </Text>
        </Flex>
      ) : null}

      {tag?.salary ? (
        <Flex className={className} left={0} top={0} mih={16} bg={theme.white}>
          <Text weight="bold" size="sm" color={theme.colors.green[5]}>
            {CurrencyConvertor(tag.salary / 100)}
          </Text>
        </Flex>
      ) : null}

      {tag?.injury ? (
        <Flex
          className={className}
          sx={{
            right: 'var(--player-card-tag-right, 0px)',
            left: 'var(--player-card-tag-left, auto)',
            bottom: 'var(--player-card-tag-bottom, 0px)',
            transform: 'var(--player-card-tag-transform, none)',
            borderRadius: theme.radius.xl,
            minHeight: 16,
            padding: `${theme.other.spacing._2}px ${theme.other.spacing._6}px`,
          }}
          bg={theme.colors.red[3]}
        >
          <DesignSystemText variant="headline-x-small" color="white">
            {tag.injury}
          </DesignSystemText>
        </Flex>
      ) : null}
    </>
  );
}

export default PlayerCardTag;
